import React, { useState, useEffect } from "react";
import {
  EditOutlined,
  DeleteOutlined,
  LikeOutlined,
  DislikeOutlined,
} from "@ant-design/icons";
import {
  Layout,
  Button,
  theme,
  ConfigProvider,
  FloatButton,
  Input,
  Row,
  Typography,
  Col,
  Card,
  Select,
  Table,
  Breadcrumb,
  Form,
  Collapse,
  Spin,
} from "antd";
import menuItems from "../../../config/data/menus.json";
import FloatButtonComp from "../../../components/FloatButtonComp";
import { useNavigate, Link } from "react-router-dom";
import BreadcrumbItem from "antd/es/breadcrumb/BreadcrumbItem";
import MainLayout from "../../../components/MainLayout";
import RecordStatus from "../../../components/RecordStatus";
import ContentTop from "../../../components/ContentTop";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

function FloatButtonGroup(props) {
  return (
    <FloatButton.Group
      shape="square"
      style={{
        right: 20,
        bottom: "40%",
      }}
      type="primary"
    >
      <FloatButtonComp
        icon={EditOutlined}
        tooltip="Edit"
        theme="primary"
        onClick={props.onEditClick}
      />
      <FloatButtonComp icon={DeleteOutlined} tooltip="Delete" theme="primary" />
      <FloatButtonComp icon={LikeOutlined} tooltip="Approve" theme="primary" />
      <FloatButtonComp
        icon={DislikeOutlined}
        tooltip="Disapprove"
        theme="primary"
      />
      <FloatButton.BackTop
        visibilityHeight={0}
        tooltip={<div>Back to Top</div>}
      />
    </FloatButton.Group>
  );
}

function MainPage(props) {
  const navigate = useNavigate();
  const [editing, setEditing] = useState(true);
  // This is reffering to the 'disabled' API of the the Text Boxes, etc. True means that 'disabled' = true.
  // const [editModeButtonsState, setEditModeButtonsState] = useState(true)
  // const [disable, setDisable] = useState(true);

  function HandleEditClick() {
    setEditing(!editing);
  }

  function onEditModeCancel() {
    setEditing(true);
  }

  function backOnClick() {
    navigate("/prd0100", { replace: true });
  }

  const onSubmit = (values) => {
    console.log("Success:", values);
  };

  return (
    <div style={{ marginBottom: 50 }}>
      <FloatButtonGroup onEditClick={HandleEditClick} />
      <ContentTop titleOfPage={"View Hooks"}>
        <BreadcrumbItem>
          <a href="/dashboard">Home</a>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <a href="/sya1500">Hooks</a>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <Text>Hook Title</Text>
        </BreadcrumbItem>
      </ContentTop>
      <div>
        <Form layout="vertical" style={{ paddingTop: 20 }} onFinish={onSubmit}>
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
            title={<Title level={3}>Hook Name</Title>}
          >
            <Row>
              <Col span={18}>
                <Card
                  style={{
                    marginBottom: "2%",
                    boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                  }}
                >
                  <div
                    style={{
                      boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                      marginBottom: 10,
                    }}
                  >
                    <div>
                      <div
                        style={{
                          border: "2px solid #F5F5F5",
                          borderRadius: 15,
                          borderBottomLeftRadius: 0,
                          borderBottomRightRadius: 0,
                          borderBottomColor: "#E2E2E2",
                        }}
                      >
                        <Row>
                          <Col
                            span={12}
                            style={{
                              backgroundColor: "#F5F5F5",
                              padding: 10,
                              borderRadius: 15,
                              borderTopRightRadius: 0,
                              borderBottomRightRadius: 0,
                              borderBottomLeftRadius: 0,
                            }}
                          >
                            <Text strong>Hook Name:</Text>
                          </Col>
                          <Col
                            span={12}
                            style={{
                              padding: 10,
                            }}
                          >
                            <Text style={{ color: "#b8b8b8" }}>
                              fyn-elastic
                            </Text>
                          </Col>
                        </Row>
                      </div>
                      <div
                        style={{
                          border: "2px solid #F5F5F5",
                          borderRadius: 0,
                          borderBottomColor: "#E2E2E2",
                        }}
                      >
                        <Row>
                          <Col
                            span={12}
                            style={{
                              backgroundColor: "#F5F5F5",
                              padding: 10,
                              borderRadius: 0,
                            }}
                          >
                            <Text strong>Status:</Text>
                          </Col>
                          <Col
                            span={12}
                            style={{
                              padding: 10,
                            }}
                          >
                            <Text style={{ color: "#b8b8b8" }}>True</Text>
                          </Col>
                        </Row>
                      </div>
                      <div
                        style={{
                          border: "2px solid #F5F5F5",
                          borderRadius: 0,
                          borderBottomColor: "#E2E2E2",
                        }}
                      >
                        <Row>
                          <Col
                            span={12}
                            style={{
                              backgroundColor: "#F5F5F5",
                              padding: 10,
                              borderRadius: 0,
                            }}
                          >
                            <Text strong>Activation Date:</Text>
                          </Col>
                          <Col
                            span={12}
                            style={{
                              padding: 10,
                            }}
                          >
                            <Text style={{ color: "#b8b8b8" }}>
                              12th January 2024
                            </Text>
                          </Col>
                        </Row>
                      </div>
                      <div
                        style={{
                          border: "2px solid #F5F5F5",
                          borderRadius: 0,
                          borderBottomColor: "#E2E2E2",
                        }}
                      >
                        <Row>
                          <Col
                            span={12}
                            style={{
                              backgroundColor: "#F5F5F5",
                              padding: 10,
                              borderRadius: 0,
                            }}
                          >
                            <Text strong>Updated On:</Text>
                          </Col>
                          <Col
                            span={12}
                            style={{
                              padding: 10,
                            }}
                          >
                            <Text style={{ color: "#b8b8b8" }}>
                              17th January 2024
                            </Text>
                          </Col>
                        </Row>
                      </div>
                      <div
                        style={{
                          border: "2px solid #F5F5F5",
                          borderRadius: 15,
                          borderTopLeftRadius: 0,
                          borderTopRightRadius: 0,
                          borderBottomColor: "#E2E2E2",
                        }}
                      >
                        <Row>
                          <Col
                            span={12}
                            style={{
                              backgroundColor: "#F5F5F5",
                              padding: 10,
                            }}
                          >
                            <Text strong>Events:</Text>
                          </Col>
                          <Col
                            span={12}
                            style={{
                              padding: 10,
                            }}
                          >
                            <Text style={{ color: "#b8b8b8" }}>
                              CREATE - CLIENT DEPOSIT - SAVINGSACCOUNT
                              WITHDRAWAL - SAVINGSACCOUNT CREATE -
                              ACCOUNTTRANSFER
                            </Text>
                          </Col>
                        </Row>
                      </div>
                      <div
                        style={{
                          border: "2px solid #F5F5F5",
                          borderRadius: 15,
                          borderTopLeftRadius: 0,
                          borderTopRightRadius: 0,
                          borderBottomColor: "#E2E2E2",
                        }}
                      >
                        <Row>
                          <Col
                            span={12}
                            style={{
                              backgroundColor: "#F5F5F5",
                              padding: 10,
                            }}
                          >
                            <Text strong>Content Type:</Text>
                          </Col>
                          <Col
                            span={12}
                            style={{
                              padding: 10,
                            }}
                          >
                            <Text style={{ color: "#b8b8b8" }}>json</Text>
                          </Col>
                        </Row>
                      </div>
                      <div
                        style={{
                          border: "2px solid #F5F5F5",
                          borderRadius: 15,
                          borderTopLeftRadius: 0,
                          borderTopRightRadius: 0,
                          borderBottomColor: "#E2E2E2",
                        }}
                      >
                        <Row>
                          <Col
                            span={12}
                            style={{
                              backgroundColor: "#F5F5F5",
                              padding: 10,
                            }}
                          >
                            <Text strong>Index Name:</Text>
                          </Col>
                          <Col
                            span={12}
                            style={{
                              padding: 10,
                            }}
                          >
                            <Text style={{ color: "#b8b8b8" }}>
                              fyn_elastic
                            </Text>
                          </Col>
                        </Row>
                      </div>
                      <div
                        style={{
                          border: "2px solid #F5F5F5",
                          borderRadius: 15,
                          borderTopLeftRadius: 0,
                          borderTopRightRadius: 0,
                          borderBottomColor: "#E2E2E2",
                        }}
                      >
                        <Row>
                          <Col
                            span={12}
                            style={{
                              backgroundColor: "#F5F5F5",
                              padding: 10,
                            }}
                          >
                            <Text strong>Payload URL:</Text>
                          </Col>
                          <Col
                            span={12}
                            style={{
                              padding: 10,
                            }}
                          >
                            <Text style={{ color: "#b8b8b8" }}>
                              {/* http://localhost:9200/fyn_elastic/_doc */}
                            </Text>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </Card>
              </Col>
            </Row>
          </Card>
        </Form>
        <Row gutter={16}></Row>
      </div>
    </div>
  );
}

const ViewSYA1500 = () => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [selectedKey, setSelectedKey] = useState("/cst0100");
  const [switchLabel, setSwitchLabel] = useState("Dark Mode");
  const [switchLabelColor, setSwitchLabelColor] = useState("#aeaeae");
  const [menuBG, setMenuBG] = useState("#2F172D");
  const [searchColorBgContainer, setSearchColorBgContainer] =
    useState("#3B2639");
  const [menuTheme, setMenuTheme] = useState("dark");
  const [leftLayoutMargin, setLeftLayoutMargin] = useState(190);
  const [logoDimensions, setLogoDimensions] = useState(100);
  const [menuSearchBarState, setMenuSearchBarState] = useState(false);
  const [menuSearchIconState, setMenuSearchIconState] = useState(true);
  const [switchLabelState, setSwitchLabelState] = useState(false);

  function onSwitchClick() {
    if (switchLabel === "Dark Mode") {
      setSwitchLabel("Light Mode");
      setMenuBG("#fff");
      setSearchColorBgContainer("#f7f8fa");
      setSwitchLabelColor("#8c8f9f");
      setMenuTheme("light");
    } else {
      setSwitchLabelColor("#aeaeae");
      setSwitchLabel("Dark Mode");
      setMenuBG("#2F172D");
      setSearchColorBgContainer("#3B2639");
      setMenuTheme("dark");
    }
  }

  function onMenuSelect(menuItems) {
    // console.log(menuItems.key);
    setSelectedKey(menuItems.key);
    navigate(menuItems.key, { replace: false });
  }

  useEffect(() => {
    if (collapsed === true) {
      setLeftLayoutMargin(71);
      setLogoDimensions(50);
      setMenuSearchBarState(true);
      setMenuSearchIconState(false);
      setSwitchLabelState(true);
    } else {
      setLeftLayoutMargin(190);
      setLogoDimensions(100);
      setMenuSearchBarState(false);
      setMenuSearchIconState(true);
      setSwitchLabelState(false);
    }
  });

  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <ConfigProvider
      theme={{
        components: {
          Layout: {
            siderBg: menuBG,
          },
          Menu: {
            darkItemBg: menuBG,
            darkSubMenuItemBg: "#241223",
          },
        },
      }}
    >
      <MainLayout
        collapsed={collapsed}
        searchColorBgContainer={searchColorBgContainer}
        theme={menuTheme}
        defaultSelectedKeys={selectedKey}
        items={menuItems}
        onClick={onMenuSelect}
        switchLabel={switchLabel}
        onSwitchClick={onSwitchClick}
        switchLabelColor={switchLabelColor}
        logoDimensions={logoDimensions}
        menuSearchBarState={menuSearchBarState}
        menuSearchIconState={menuSearchIconState}
        switchLabelState={switchLabelState}
        setCollapsed={setCollapsed}
        leftLayoutMargin={leftLayoutMargin}
        colorBgContainer={colorBgContainer}
      >
        <MainPage titleOfPage={"View Hooks"} />
        <RecordStatus
          authStatus={"Authorised"}
          makerID={""}
          makerDate={"2023-10-27"}
          checkerID={" "}
          checkerDate={"2023-10-27"}
        />
      </MainLayout>
    </ConfigProvider>
  );
};
export default ViewSYA1500;
